function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { declMod } from '@yandex-lego/i-bem-react';
import _button2__control from "./../__control/button2__control.react.js";

var Control = _button2__control.applyDecls();

import "./../__control/button2__control.css";
export default declMod(function (_ref) {
  var hasControl = _ref.hasControl;
  return hasControl;
}, {
  block: 'button2',
  tag: 'span',
  mods: function mods() {
    return _objectSpread({}, this.__base.apply(this, arguments), {
      'has-control': 'yes'
    });
  },
  attrs: function attrs() {
    return _objectSpread({}, this.__base.apply(this, arguments), {
      type: undefined,
      name: undefined,
      value: undefined,
      id: undefined,
      tabIndex: undefined,
      disabled: undefined,
      'aria-disabled': undefined,
      autoComplete: undefined
    });
  },
  content: function content(_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        value = _ref2.value,
        tabIndex = _ref2.tabIndex,
        disabled = _ref2.disabled,
        _ref2$control = _ref2.control,
        control = _ref2$control === void 0 ? {} : _ref2$control;
    var attrs = control.attrs,
        type = control.type,
        mix = control.mix;
    var extendedAttrs = {};

    if (['checkbox', 'radio'].indexOf(type) >= 0) {
      extendedAttrs = {
        'aria-checked': this.state.checked || undefined,
        defaultChecked: this.state.checked || false
      };
    }

    return [].concat(_toConsumableArray(this.__base.apply(this, arguments)), [React.createElement(Control, _extends({
      id: id,
      name: name,
      value: value,
      disabled: disabled,
      mix: mix,
      attrs: _objectSpread({}, attrs, {}, extendedAttrs),
      type: type
    }, {
      tabIndex: tabIndex,
      key: "control"
    }))]);
  }
});